import type { DrawerProps } from './Drawer';

export interface OldDrawerProps
  extends Omit<DrawerProps, 'open' | 'shouldCloseOnOutsideClick' | 'shouldCloseOnEscapeKey'> {
  /** @deprecated open을 대신 사용해주세요. */
  opened?: boolean;
  /** @deprecated shouldCloseOnOutsideClick을 대신 사용해주세요. */
  canClickOutside?: boolean;
  /** @deprecated shouldCloseOnEscapeKey를 대신 사용해주세요. */
  canCloseEscapeKey?: boolean;
}

export function convertOldDrawerProps(props: OldDrawerProps): DrawerProps {
  const { opened, canClickOutside, canCloseEscapeKey, ...restProps } = props;

  return {
    ...restProps,
    open: opened,
    shouldCloseOnOutsideClick: canClickOutside,
    shouldCloseOnEscapeKey: canCloseEscapeKey,
  };
}
